module.exports = __webpack_public_path__ + "img/gongxueyun-logo.fa9b6bca.png";